import moment from "moment/moment";


export const toVerifyCase = (str) => {
  if (str === null || str === undefined) return '';
  return str.toLowerCase()
}

export const to2Decimal = (num) => {
  if (num === null || num === undefined || isNaN(num)) return '';
  return Number(num).toFixed(2);
};

export const toProperCase = (str) => {
  let string
  if (str === null || !str) {
    string = ''
  } else {
    string = str
  }
    return string
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim()
      ;
  };
  
export const formatDate = (date)=>{
  let validData
  if (moment(date).format('YYYY-MM-DD') === '1900-01-01' || date === null || date?.trim() === '') {
    validData = ''
  } else {
    validData = moment(date).format('DD MMM YY')
  }
  return validData
}

export const formatTime = (time) => {
  if (!time || time.trim() === '') return '';
  return moment(time, ['HH:mm', 'hh:mm A', 'HH:mm:ss']).format('hh:mm A');
};


// format DD MMM YYYY
export const formatDateFullYear = (date)=>{
  let validData
  if (moment(date).format('YYYY-MM-DD') === '1900-01-01' || date === null || date?.trim() === '') {
    validData = ''
  } else {
    validData = moment(date).format('DD MMM YYYY')
  }
  return validData
}


export const formatDateDay = (date)=>{
  let validData
  if (moment(date).format('YYYY-MM-DD') === '1900-01-01' || date === null || date?.trim() === '') {
    validData = ''
  } else {
    validData = moment(date).format('DD')
  }
  return validData
}

export const formatDateYear = (date)=>{
  let validData
  if (moment(date).format('YYYY-MM-DD') === '1900-01-01' || date === null || date?.trim() === '') {
    validData = ''
  } else {
    validData = moment(date).format('MMM YY')
  }
  return validData
}

export const formatTotals = (amount) => {
  let validData;
  if (amount === null || amount === '' || amount === 0) {
    validData = '0.00';
  } else {
    validData = Math.round(Math.abs(amount)).toFixed(2);
  }
  return validData;
};

export const formatAmount = (amount) => {
  let validData;
  if (amount === null || amount === '' || amount === 0) {
    validData = '0.00';
  } else {
    validData = Math.abs(amount).toFixed(2);
  }
  return validData;
}

export const toFixed2 = (value) => Number(value || 0).toFixed(2);

export const isDateInFinancialRange = (date,selectedFyear) => {
  console.log("date:", date);
  if (!selectedFyear || !date) return false;

  const start = moment(selectedFyear.fdate, "YYYY-MM-DD");
  const end = moment(selectedFyear.tdate, "YYYY-MM-DD");
  const selected = moment(date, "YYYY-MM-DD");

  // Avoid invalid date cases
  if (!start.isValid() || !end.isValid() || !selected.isValid()) return false;

  const isValid = selected.isBetween(start, end, "day", "[]");

  if (!isValid) {
    // showToast("error", "Selected date does not lie in financial range");
  }

  return isValid;
};



